import { GLOBALS_USER } from './globals-user';

/**
 * Export Production Environment. No changes shall me made in this file.
 */
export const environmentUser = {
  ...GLOBALS_USER,
};
